import { Component, Input } from '@angular/core';
import { FacilityLocation, FacilityLocationSearchComponent, ProviderLocationIdentifier } from '@harlowe/core';
import { TealCompEncounterDetails, TealCompEncounterUpdate } from '../../../models/encounter';
import { EncounterService } from '../../../services/encounter.service';
import { NgIf } from '@angular/common';
import { AnimateModule } from 'primeng/animate';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { PanelModule } from 'primeng/panel';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormsModule } from '@angular/forms';
import { FloatLabelModule } from 'primeng/floatlabel';
import { TealCompReferralUpdate } from '../../../models/teal-comp-referral';
import { ReferralService } from '../../../services/referral.service';

@Component({
  selector: 'app-encounter-facility-block',
  standalone: true,
  imports: [FacilityLocationSearchComponent, NgIf, AnimateModule, 
            ButtonModule, CardModule, PanelModule, InputNumberModule, 
            FormsModule, FloatLabelModule],
  templateUrl: './encounter-facility-block.component.html',
  styleUrl: './encounter-facility-block.component.scss'
})
export class EncounterFacilityBlockComponent 
{
  @Input() encounter: TealCompEncounterDetails | undefined

  constructor(private _encounters: EncounterService, private _referrals: ReferralService)
  {

  }


  editProposed: boolean = false;

  editRequested: boolean = false;
  proposedCostEdited: boolean = false;
  requestedCostEdited: boolean = false;
  get locked() : boolean
  {
    if(this.encounter)
      return this.encounter?.status >=5
    else
      return false;
  }

  get allowProposedEdit() : boolean 
  {
    //If there are any active appointments, don't allow edit
    var activeAppt = this.encounter?.appointments?.find(a => a.status <=2);
    if(activeAppt)
      {
        return false;
      }
    else
      return true;
  }

  async proposedProviderSelected(provider:FacilityLocation)
  {
    if(this.encounter && this.encounter.proposedProvider)
    {
      var eu: TealCompEncounterUpdate = new TealCompEncounterUpdate(this.encounter.id);
      eu.proposedProviderId = new ProviderLocationIdentifier(this.encounter.proposedProvider.facility.ein,this.encounter.proposedProvider.facility.npi, this.encounter.proposedProvider.location.id);
      await this._encounters.updateEncounter(this.encounter.id,eu);
    }
  }

  async requestedProviderSelected(provider:FacilityLocation)
  {
    if(this.encounter && this.encounter.requestedProvider)
    {
      var ru: TealCompReferralUpdate = new TealCompReferralUpdate(this.encounter.id);
      ru.servicingProviderId = new ProviderLocationIdentifier(this.encounter.requestedProvider.facility.ein,this.encounter.requestedProvider.facility.npi, this.encounter.requestedProvider.location.id);
      await this._referrals.updateReferral(this.encounter.referral.id,ru);
    }
  }

  async confirmedProviderSelected(provider: FacilityLocation)
  {
    if(this.encounter && this.encounter.confirmedProvider)
      {
        var eu: TealCompEncounterUpdate = new TealCompEncounterUpdate(this.encounter.id);
        eu.proposedProviderId = new ProviderLocationIdentifier(this.encounter.confirmedProvider.facility.ein,this.encounter.confirmedProvider.facility.npi, this.encounter.confirmedProvider.location.id);
        await this._encounters.updateEncounter(this.encounter.id,eu);    
      }
  }

  async updateEstimatedCosts()
  {
    if(this.encounter)
      {
        var eu: TealCompEncounterUpdate = new TealCompEncounterUpdate(this.encounter.id);
        eu.estimatedProposedCost = this.encounter.estimatedProposedCost;
        eu.estimatedRequestedCost = this.encounter.estimatedRequestedCost;
        await this._encounters.updateEncounter(this.encounter.id,eu);    
      }
  }

}
